export const isNativeApp = "__TAURI_INTERNALS__" in window;
